import { HrefLangActions, HrefLangType } from './hrefLang.interface';
import { HrefLangActionsType } from './reducer';

export const addHrefLang = (payload: HrefLangType[]): HrefLangActionsType => ({
  type: HrefLangActions.Add,
  payload,
});
